import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CommissionData } from '../model/commission-data';

@Injectable({
    providedIn: 'root',
})
export class SelectedComissionService {
    perComission: CommissionData = null;
    private sourceComission = new BehaviorSubject<CommissionData>(this.perComission);
    dataComission$ = this.sourceComission.asObservable();

    public saveData(commission) {
        this.perComission = commission;
        this.sourceComission.next(this.perComission);
    }

    public clearData() {
        this.perComission = null;
        this.sourceComission.next(null);
    }
}
